import { Alert, Stack, Text } from '@backyard-ui/core';

export default function ErrorDisclaimer() {
  return (
    <Alert.Root
      variant="subtle"
      appearance="critical"
      data-testid="error-alert-text"
    >
      <Alert.Content>
        <Alert.Description>
          <Stack spacing="2">
            <Alert.Icon />
            <Text size="sm" color="gray-800">
              Tivemos um problema ao exibir o frete. Você pode conferí-lo no
              carrinho.
            </Text>
          </Stack>
        </Alert.Description>
      </Alert.Content>
    </Alert.Root>
  );
}
